import dynamic from "next/dynamic";

const DynamicSelectLGSDialog = dynamic(
  () =>
    import("modules/lgs/components/stores/settings/SelectLGSDialog").then(
      (mod) => mod.SelectLGSDialog
    ),
  {
    loading: () => <></>,
  }
);

export default DynamicSelectLGSDialog;
